module.exports = __webpack_public_path__ + "img/logo_Generalseguros.3903c3bf.svg";